import { useState } from 'react';
import Image from 'next/image';

import { cn, customImageLoader } from '@restworld/utils-common';

export default function BlurImage({
  alt,
  src,
  className: customStyles,
  fill,
  dimensions,
}: {
  src: string;
  alt: string;
  className?: string;
  fill?: boolean;
  dimensions?: { width: number; height: number };
}) {
  const [isLoading, setLoading] = useState(true);

  return (
    <StyledImage
      src={src}
      alt={alt}
      fill={fill}
      priority
      onLoadingComplete={() => setLoading(false)}
      isLoading={isLoading}
      customStyles={customStyles}
      // blurDataURL="https://placehold.co/1024x1024"
      {...dimensions}
      loader={customImageLoader}
    />
  );
}
const StyledImage = ({
  isLoading,
  customStyles,
  className,
  ...props
}: {
  isLoading?: boolean;
  customStyles?: string;
} & React.ComponentProps<typeof Image>) => (
  <Image className={cn('object-cover', isLoading ? 'bg-gray-500' : '', customStyles, className)} {...props} />
);
